import http from 'plugins/axios';

export default {
  reqList(data) {
    return http.get({
      url: '/admin/airDropTask/mining/list/task',
      data
    });
  },
  exportExcelMoulds() {
    return http.get({
      url: '/admin/airDropTask/mining/export/excel/moulds',
      responseType: "blob",
    });
  },
  setExcuteTask(data) {
    return http.post({
      url: '/admin/airDropTask/mining/setExcuteTask',
      data,
      dataType: 'form'
    });
  },
  create(data) {
    return http.post({
      url: '/admin/airDropTask/mining/createTask',
      data,
      dataType: 'form'
    });
  },
  reqAirDrops(data) {
    return http.get({
      url: '/admin/airDropTask/mining/list/airdrop',
      data
    });
  },
  reqUnTransfer(data) {
    return http.get({
      url: '/admin/airDropTask/mining/list/unTransfer',
      data
    });
  },
  checkAirDrop(data) {
    return http.post({
      url: '/admin/airDropTask/mining/checked/airdrop',
      data,
      dataType: 'form'
    });
  },
  importAirDrop(data) {
    return http.post({
      url: '/admin/airDropTask/mining/save/airdrop',
      data,
      dataType: 'form'
    });
  },

  resetError(data) {
    return http.post({
      url: '/admin/airDropTask/mining/reset',
      data,
      dataType: 'form'
    });
  },

};
